import Error from 'next/error'
import { MetaSeo } from '../../components/index'
import { PAGINEDETAIL, NEWS } from '../../utils/endpoint'
import { api } from '../../utils'
import React from 'react'
import PropTypes from 'prop-types'
import NewsTemplate from '../../components/template/NewsTemplate/NewsTemplate'

const News = ({ page, statusCode, news }) => {
  if (!page) return <Error statusCode={statusCode} />
  return (
    <>
      <NewsTemplate news={news} page={page} />
    </>
  )
}

export async function getServerSideProps({ params, locale }) {
  const pageResponse = await api.get(PAGINEDETAIL, { params: { chiave: 'news', lang: locale } })
  const page = await pageResponse.data
  const newsResponse = await api.get(NEWS, {
    params: { lang: locale },
  })
  const news = await newsResponse.data

  const toolbarProps = { toolbarPage: page }
  return {
    props: { page, ...toolbarProps, news },
  }
}

News.propTypes = {
  page: PropTypes.object,
  statusCode: PropTypes.number,
  i18n: PropTypes.object,
  t: PropTypes.func,
}

export default News
